import React from 'react';
import * as S from './SearchResultsLoader.styles';
import WifiIcon from '../../../../Icons/Amenities/WifiIcon';
import OfferIcon from '../../../../Icons/OfferIcon';
import DoubleBuildingIcon from '../../../../Icons/DoubleBuildingIcon';
import SwimmingIcon from '../../../../Icons/Amenities/SwimmingIcon';
import FreeBreakfast from '../../../../Icons/Amenities/FreeBreakfast';
import {defaultTheme} from '@stencil/build-theme';

const SearchResultsLoader = () => {
  return (
    <S.OverlayBackround>
      <S.SearchResultsLoaderContainer>
        <S.SearchresultLoadericonsWrap>
          <WifiIcon width="2.8rem" height="2.5rem" fill={defaultTheme.colors.goBrandBlue.medium} />
          <OfferIcon width="4rem" height="4rem" fill={defaultTheme.colors.goBrandBlue.medium} />
          <DoubleBuildingIcon
            width="10rem"
            height="10rem"
            fill={defaultTheme.colors.goBrandBlue.medium}
          />
          <SwimmingIcon width="4rem" height="4rem" fill={defaultTheme.colors.goBrandBlue.medium} />
          <FreeBreakfast
            width="2.8rem"
            height="2.7rem"
            fill={defaultTheme.colors.goBrandBlue.medium}
          />
          <S.SearchInputIconWrap />
        </S.SearchresultLoadericonsWrap>
        <S.SearchResultsLoaderLabel>LOADING THE BEST PRICES FOR YOU!</S.SearchResultsLoaderLabel>
        {/* <S.SearchResultsLoaderSubLabel>
          We get you the best prices, everytime. Serving over 600k customers worldwide everyday
        </S.SearchResultsLoaderSubLabel> */}
      </S.SearchResultsLoaderContainer>
    </S.OverlayBackround>
  );
};

export default SearchResultsLoader;
